<template>
    <v-app>
      <v-row class="submit-post-payout pa-3">
        <v-flex xs12 sm12>
          <v-card class="card-box">
            <v-card-title primary-title>
              <v-layout wrap>
                <v-flex xs12 md12 v-if="isCurrentUser && !isNotInfluencer">
                  <v-text-field
                    label="Campaign Name"
                    v-model="campaignPayout.campaignName"
                    filled readonly
                    v-if="isCampaign"
                  ></v-text-field>
                  <v-autocomplete
                    filled
                    :items="campaigns"
                    label="Select Campaign"
                    item-value="id"
                    item-text="name"
                    v-model="campaignPayout.campaignID"
                    @change="changeCampaign"
                    v-else
                  ></v-autocomplete>
                </v-flex>
                <v-flex xs12 md12 v-if="!isCurrentUser || isNotInfluencer">
                  <div class="mb-2">
                    <span class="h4 font-weight-bold mb-2">Campaign Name</span>:&nbsp;
                    <span class="h5 font-weight-bold mb-2" style="font-size:16px">{{ campaignPayout.campaignName }}</span>
                  </div>
                  <div class="mb-2">
                    <span class="h4 font-weight-bold mb-2">Creator Handle</span>:&nbsp;
                    <span class="h5 font-weight-bold mb-2" style="font-size:16px">{{ campaignPayout.fullName }} ({{ campaignPayout.handle }})</span>
                  </div>
                </v-flex>
                <v-flex xs12 md12>
                  <div class="deliverables" v-if="isStoryTell && deliverables">
                    Your deliverables for this campaign:
                    <post-deliverables :deliverables="deliverables"/>              
                  </div>
                </v-flex>
              </v-layout>
            </v-card-title>
          </v-card>
          <div class="card-box" v-if="campaignPayout.campaignID">
            <v-stepper v-model="mainStep">
              <v-stepper-header>
                <v-stepper-step
                  step="1"
                  :complete="mainStep > 1"
                >Stats submission & Ratings</v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step step="2" :complete="mainStep > 2">Feedback Questions</v-stepper-step>

                <v-divider></v-divider>

                <v-stepper-step step="3">Others</v-stepper-step>
              </v-stepper-header>
              <v-stepper-items class="stepper-items">
                <v-stepper-content :step="1" class="pa-1">
                  <v-stepper v-model="firstActiveStep" vertical class="card-box" v-if="firstSteppers.length">
                    <div :key="stepIndex" v-for="(step, stepIndex) in firstSteppers">
                      <span class="d-none">{{stepIndex}}</span>
                      <!-- Story Coverage -->
                      <v-stepper-step editable :complete="firstActiveStep > (stepIndex + 1)" :step="stepIndex + 1" v-if="step.type === 'storyCoverage'">
                        Upload your coverage and statistics for IG Story(ies)
                        <v-btn
                        text
                        small
                        color="secondary"
                        @click="showPayoutSampleDialog('igStory')"
                        class="ma-0 pa-0"
                        >
                          <v-icon center small>mdi-newspaper</v-icon> View stats required here
                        </v-btn>
                      </v-stepper-step>
                      <v-stepper-content :step="stepIndex + 1" v-if="step.type === 'storyCoverage'">
                        <v-card flat class="ma-2" :key="index" v-for="(story, index) in campaignPayout.stories">
                          <v-text-field
                            label="label"
                            hint="label IGS 1, IGS 2 etc for multiple stories"
                            persistent-hint
                            outlined
                            v-model="story.label"
                            dense
                          >
                            <template v-slot:append-outer>
                              <v-btn style="margin-top:-6px" dark icon @click="deletePostGroup(campaignPayout.stories, index)">
                                <v-icon dark color="red">cancel</v-icon>
                              </v-btn>
                            </template>
                          </v-text-field>
                          <v-row class="mb-5">
                            <v-col
                              v-for="(img, imgIndex) in story.showImages"
                              :key="imgIndex"
                              class="d-flex child-flex img-box"
                              cols="4"
                            >
                              <v-hover v-slot:default="{ hover }">
                                <v-card
                                  flat
                                  tile
                                  class="d-flex"
                                  :elevation="hover ? 16 : 2"
                                >
                                  <v-img
                                    :src="img.thumbnail"
                                    :lazy-src="img.thumbnail"
                                    aspect-ratio="1"
                                    class="grey lighten-2"
                                  ></v-img>
                                  <v-overlay absolute>
                                    <v-btn dark icon @click="deleteCustomImage(story, imgIndex)">
                                      <v-icon dark color="red">cancel</v-icon>
                                    </v-btn>
                                  </v-overlay>
                                </v-card>
                              </v-hover>
                            </v-col>
                            <v-col class="d-flex child-flex img-box" cols="4">
                              <v-responsive :aspect-ratio="1">
                                <v-card
                                  outlined
                                  flat
                                  tile
                                  style="height: 100%"
                                  class="d-flex"
                                  @click="showFileUploader('storyUpload'+index)"
                                >
                                  <v-btn dark icon class="ma-auto">
                                    <v-icon dark color="primary">add</v-icon>
                                  </v-btn>
                                  <input
                                    type="file"
                                    name="images"
                                    style="display: none"
                                    :ref="'storyUpload'+index"
                                    :id="'storyUpload'+index"
                                    accept="image/*, video/*"
                                    @change="prepareCustomUpload($event, story)"
                                  />
                                </v-card>
                              </v-responsive>
                            </v-col>
                          </v-row>
                        </v-card>
                        <v-row>
                          <v-col>
                            <v-btn color="secondary" small @click="addMore('stories')"><v-icon left>mdi-newspaper-plus</v-icon>Add More</v-btn>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col>
                            <v-btn color="secondary" @click="firstActiveStep = stepIndex + 2">Continue</v-btn>
                          </v-col>
                        </v-row>
                      </v-stepper-content>

                      <!-- Post URL -->
                      <v-stepper-step editable :complete="firstActiveStep > (stepIndex + 1) " :step="stepIndex + 1" v-if="step.type === 'postURL'">
                        Enter the URL to your in-feed content here
                        <!-- <small>Ignore if the Post's URL is already included</small> -->
                      </v-stepper-step>
                      <v-stepper-content :step="stepIndex + 1" v-if="step.type === 'postURL'">
                        <v-card flat class="ma-2" :key="index" v-for="(post, index) in campaignPayout.posts">
                          <v-text-field
                            label="Post URL"
                            outlined
                            v-model="post.instagramPostURL"
                            dense
                          >
                            <template v-slot:append-outer>
                              <v-btn style="margin-top:-6px" dark icon @click="deletePostGroup(campaignPayout.posts, index)">
                                <v-icon dark color="red">cancel</v-icon>
                              </v-btn>
                            </template>
                          </v-text-field>
                          <!-- Please attach all screenshots of all your lived post statistics (eg includes ig stories, ig post/carousel, or ig video) -->
                          <v-row class="mb-2">
                            <v-col
                              v-for="(img, imgIndex) in post.showImages"
                              :key="imgIndex"
                              class="d-flex child-flex img-box"
                              cols="4"
                            >
                              <v-hover v-slot:default="{ hover }">
                                <v-card
                                  flat
                                  tile
                                  class="d-flex"
                                  :elevation="hover ? 16 : 2"
                                >
                                  <v-img
                                    :src="img.thumbnail"
                                    :lazy-src="img.thumbnail"
                                    aspect-ratio="1"
                                    class="grey lighten-2"
                                  ></v-img>
                                  <v-overlay absolute>
                                    <v-btn dark icon @click="deleteCustomImage(post, imgIndex)">
                                      <v-icon dark color="red">cancel</v-icon>
                                    </v-btn>
                                  </v-overlay>
                                </v-card>
                              </v-hover>
                            </v-col>
                            <v-col class="d-flex child-flex img-box" cols="4">
                              <v-responsive :aspect-ratio="1">
                                <v-card
                                  outlined
                                  flat
                                  tile
                                  style="height: 100%"
                                  class="d-flex"
                                  @click="showFileUploader('mediaUpload'+index)"
                                >
                                  <v-btn dark icon class="ma-auto">
                                    <v-icon dark color="primary">add</v-icon>
                                  </v-btn>
                                  <input
                                    type="file"
                                    name="images"
                                    style="display: none"
                                    :ref="'mediaUpload'+index"
                                    :id="'mediaUpload'+index"
                                    accept="image/*, video/*"
                                    @change="prepareCustomUpload($event, post)"
                                  />
                                </v-card>
                              </v-responsive>
                            </v-col>
                          </v-row>
                        </v-card>
                        <v-row>
                          <v-col>
                            <v-btn color="secondary" small @click="addMore('posts')"><v-icon left>mdi-newspaper-plus</v-icon>Add More</v-btn>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col>
                            <v-btn color="secondary" @click="firstActiveStep = stepIndex + 2">Continue</v-btn>
                          </v-col>
                        </v-row>
                      </v-stepper-content>
                      <!-- {{stepIndex}} {{step}} -->

                      <!-- Deliverables -->
                      <v-stepper-step editable :complete="firstActiveStep > (stepIndex + 1)" :step="stepIndex + 1" v-if="step.type === 'deliverable'">
                        {{getDeliverablePost(step.fields.name).title}}
                        <v-btn
                        text
                        small
                        color="secondary"
                        @click="showPayoutSampleDialog(getDeliverablePost(step.fields.name).sampleType)"
                        class="ma-0 pa-0"
                        v-if="getDeliverablePost(step.fields.name).sampleType !== 'custom' && getDeliverablePost(step.fields.name).sampleType !== 'youtube'"
                        >
                          <v-icon center small>mdi-newspaper</v-icon> View stats required here
                        </v-btn>
                      </v-stepper-step>
                      <v-stepper-content :step="stepIndex + 1" v-if="step.type === 'deliverable'">
                        <div :key="contentIndex" v-for="(allPost, contentIndex) in campaignPayout.deliverablePosts">
                          <div v-if="allPost.type === step.fields.name">
                            <v-card flat class="ma-2" :key="index" v-for="(post, index) in campaignPayout.deliverablePosts[contentIndex].posts">
                              <v-text-field
                                :label="getLabel(step.fields.name)"
                                hide-details
                                outlined
                                v-model="post.label"
                                dense
                              >
                                <template v-slot:append-outer>
                                  <v-btn style="margin-top:-6px" dark icon @click="deletePostGroup(campaignPayout.deliverablePosts[contentIndex].posts, index)">
                                    <v-icon dark color="red">cancel</v-icon>
                                  </v-btn>
                                </template>
                              </v-text-field>
                              <p class="text-danger" v-if="!campaignPayout.deliverablePosts[contentIndex].posts[index].label">This field is required</p>
                              <v-row class="mb-5 mt-2">
                                <v-col
                                  v-for="(img, imgIndex) in post.showImages"
                                  :key="imgIndex"
                                  class="d-flex child-flex img-box"
                                  cols="4"
                                >
                                  <v-hover v-slot:default="{ hover }">
                                    <v-card
                                      flat
                                      tile
                                      class="d-flex"
                                      :elevation="hover ? 16 : 2"
                                    >
                                    <video
                                      v-if="isVideo(img.thumbnail)"
                                      :src="img.thumbnail"
                                      controls>             
                                          Your browser does not support the video tag.
                                      </video>
                                      <v-img
                                        :src="img.thumbnail"
                                        :lazy-src="img.thumbnail"
                                        aspect-ratio="1"
                                        class="grey lighten-2"
                                      ></v-img>
                                      <v-overlay absolute>
                                        <v-btn dark icon @click="deleteCustomImage(post, imgIndex)">
                                          <v-icon dark color="red">cancel</v-icon>
                                        </v-btn>
                                      </v-overlay>
                                    </v-card>
                                  </v-hover>
                                </v-col>
                                <v-col class="d-flex child-flex img-box" cols="4">
                                  <v-responsive :aspect-ratio="1">
                                    <v-card
                                      outlined
                                      flat
                                      tile
                                      style="height: 100%"
                                      class="d-flex"
                                      @click="showFileUploader('deliverableUpload'+contentIndex+index)"
                                    >
                                      <v-btn dark icon class="ma-auto">
                                        <v-icon dark color="primary">add</v-icon>
                                      </v-btn>
                                      <input
                                        type="file"
                                        name="images"
                                        style="display: none"
                                        :ref="'deliverableUpload'+contentIndex+index"
                                        :id="'deliverableUpload'+contentIndex+index"
                                        accept="image/*, video/*"
                                        @change="prepareCustomUpload($event, post)"
                                      />
                                    </v-card>
                                  </v-responsive>
                                </v-col>
                              </v-row>
                              <p class="text-danger mb-5" style="margin-top:-30px;" v-if="!post.showImages.length">This field is required</p>
                            </v-card>
                            <v-row>
                              <v-col>
                                <v-btn color="secondary" small @click="addMore('deliverables', contentIndex)"><v-icon left>mdi-newspaper-plus</v-icon>Add More</v-btn>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col>
                                <v-btn color="secondary" @click="firstActiveStep = stepIndex + 2">Continue</v-btn>
                              </v-col>
                            </v-row>
                          </div>
                        </div>
                      </v-stepper-content>
                      <!-- Client Overall Exp -->
                      <v-stepper-step editable :complete="firstActiveStep > (stepIndex + 1)" :step="stepIndex + 1" v-if="step.type === 'advertiserSatisfactionLevel'">
                        How would you rate your overall experience with the client?
                      </v-stepper-step>
                      <v-stepper-content :step="stepIndex + 1" v-if="step.type === 'advertiserSatisfactionLevel'">
                        <v-rating v-model="campaignPayout.advertiserSatisfactionLevel" size="30" dense color="secondary" class="mb-5" @input="firstActiveStep = stepIndex + 2"></v-rating>
                      </v-stepper-content>

                      <!-- Kobe Overall Exp -->
                      <v-stepper-step editable :complete="firstActiveStep > (stepIndex + 1)" :step="stepIndex + 1" v-if="step.type === 'kobeSatisfactionLevel'">
                        How would you rate your overall experience with Kobe?
                      </v-stepper-step>
                      <v-stepper-content :step="stepIndex + 1" v-if="step.type === 'kobeSatisfactionLevel'">
                        <v-rating v-model="campaignPayout.kobeSatisfactionLevel" size="30" dense color="secondary" class="mb-5" @input="firstActiveStep = stepIndex + 2"></v-rating>
                      </v-stepper-content>
                    </div>
                  </v-stepper>
                  <div class="text-right pa-3">
                    <v-btn
                      color="secondary"
                      @click="proceedStepTwo"
                    >Next</v-btn>
                  </div>
                </v-stepper-content>
                <v-stepper-content :step="2" class="pa-1">
                  <p class="body-2 pa-3 pt-5 pb-0">The questions below will allow us to share on behalf your experience and feedback, during the review meeting with the clients:</p>
                  <v-stepper v-model="secondActiveStep" vertical class="card-box">
                    <!-- Client Overall Exp -->
                    <v-stepper-step editable :complete="secondActiveStep > 1" step="1">
                      What do you like most about this product/service you are promoting? <span class="text-danger">*</span>
                    </v-stepper-step>
                    <v-stepper-content step="1">
                      <v-textarea
                          label=""
                          outlined
                          v-model="campaignPayout.promotingProducts"
                        ></v-textarea>
                      <v-btn class="mb-2" color="secondary" :disabled="!campaignPayout.promotingProducts" @click="secondActiveStep = 2">Continue</v-btn>
                    </v-stepper-content>

                    <!-- improvment areas -->
                    <v-stepper-step editable :complete="secondActiveStep > 2" step="2">
                      What are areas of improvement about this product/service that will be valuable feedback for them? <span class="text-danger">*</span>
                    </v-stepper-step>
                    <v-stepper-content step="2">
                      <v-textarea
                          label=""
                          outlined
                          v-model="campaignPayout.improved"
                        ></v-textarea>
                      <v-btn class="mb-2" color="secondary" :disabled="!campaignPayout.improved" @click="secondActiveStep = 3">Continue</v-btn>
                    </v-stepper-content>

                    <!-- audience enjoyment -->
                    <v-stepper-step editable step="3">
                      What do you think your audience enjoyed about your content? <span class="text-danger">*</span>
                    </v-stepper-step>
                    <v-stepper-content step="3">
                      <v-textarea
                          label=""
                          outlined
                          v-model="campaignPayout.audienceEnjoyment"
                        ></v-textarea>
                    </v-stepper-content>
                  </v-stepper>
                  <div class="text-right pa-3">
                    <v-btn text color="info" @click="mainStep=1">
                      <v-icon small style="margin-right: 5px;" >mdi-arrow-left-circle</v-icon>
                        Back
                    </v-btn>
                    <v-btn color="secondary" :disabled="disableStepTwo" @click="mainStep=3">Next</v-btn>
                  </div>
                </v-stepper-content>
                <v-stepper-content :step="3" class="pa-1">
                  <v-stepper v-model="thirdActiveStep" vertical class="card-box">
                    <!-- Banking Information -->
                    <!-- <v-stepper-step editable :complete="thirdActiveStep > 1" step="1" v-if="isCurrentUser">
                      Please check your banking information before submitting the payout:
                    </v-stepper-step>
                    <v-stepper-content step="1" v-if="isCurrentUser">
                      <v-card flat class="body-2 mt-2 pa-0">
                        <v-row justify="end" align="right">
                          <v-col md="12" xs="12" class="text-right">
                            <v-btn color="warning" small class="mb-2" v-if="!editProfile" @click="openProfileEdit">
                              <v-icon small>edit</v-icon>
                            </v-btn>
                            <v-btn color="success" small class="mb-2" v-if="editProfile" @click="saveProfile">Update</v-btn>
                            <v-btn color="warning" small class="mb-2" v-if="editProfile" @click="cancelEdit">Cancel</v-btn>
                          </v-col>
                        </v-row>
                        <div class="blue-grey lighten-3" style="overflow-x:auto;">
                          <table>
                            <tr>
                              <td>Full Name <small>(as per bank account)</small></td>
                              <td>
                                <div v-if="editProfile">
                                  <v-text-field
                                    class="edit-field"
                                    v-model="editData.fullName"
                                    dense
                                    outlined
                                    v-on="on"
                                    hide-details
                                  ></v-text-field>
                                </div>
                                <span v-else>{{user.fullName || 'N/A'}}</span>
                              </td>
                            </tr>
                            <tr>
                              <td>Bank Name</td>
                              <td>
                                <div v-if="editProfile">
                                  <v-combobox
                                    class="edit-field"
                                    v-model="editData.bankName"
                                    :items="bankNames"
                                    item-text="bank"
                                    item-value="bank"
                                    :search-input.sync="newBankName"
                                    attach
                                    dense
                                    hide-details
                                    outlined
                                  >
                                    <template v-slot:no-data>
                                      <v-list-item>
                                        <span class="subheading pr-2" v-if="newBankName">{{ newBankName }}</span>
                                      </v-list-item>
                                    </template>
                                  </v-combobox>
                                </div>
                                <span v-else>{{user.bankName || 'N/A'}}</span>
                              </td>
                            </tr>
                            <tr>
                              <td>Bank Account Number</td>
                              <td>
                                <div v-if="editProfile">
                                  <v-text-field
                                    class="edit-field"
                                    v-model="editData.bankAccount"                     
                                    v-mask="'#################'"
                                    dense
                                    outlined
                                    v-on="on"
                                    hide-details
                                  ></v-text-field>
                                </div>
                                <span v-else>{{user.bankAccount || 'N/A'}}</span>
                              </td>
                            </tr>
                            <tr>
                              <td>Email</td>
                              <td>
                                <div v-if="editProfile">
                                  <v-text-field
                                    class="edit-field"
                                    v-model="editData.email"
                                    dense
                                    outlined
                                    v-on="on"
                                    hide-details
                                  ></v-text-field>
                                </div>
                                <span v-else>{{user.email || 'N/A'}}</span>
                              </td>
                            </tr>
                            <tr>
                              <td>Mailing Address</td>
                              <td>
                                <div v-if="editProfile">
                                  <v-text-field
                                    class="edit-field"
                                    v-model="editData.mailingAddress"
                                    dense
                                    outlined
                                    v-on="on"
                                    hide-details
                                  ></v-text-field>
                                </div>
                                <span v-else>{{user.mailingAddress || 'N/A'}}</span>
                              </td>
                            </tr>
                          </table>
                          <div class="caption">If you seeing 'N/A' or never filled up the information, Please update your <router-link :to="{path:'profile'}">profile</router-link> before submission.</div>
                        </div>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn class="mb-2" color="secondary" @click="thirdActiveStep = 2">Continue</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-stepper-content> -->
                    <!-- other campaigns -->
                    <v-stepper-step editable :complete="thirdActiveStep > 1" step="1">
                      What other campaigns would you want to work more on with us?
                    </v-stepper-step>
                    <v-stepper-content step="1">
                      <v-card flat class="body-2 mt-2 pa-0">
                        <v-textarea
                          label=""
                          outlined
                          v-model="campaignPayout.otherCampaigns"
                        ></v-textarea>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn class="mb-2" color="secondary" @click="thirdActiveStep = 2">Continue</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-stepper-content>
                    <v-stepper-step editable step="2">
                      Upload Invoice for agencies (optional)
                    </v-stepper-step>
                    <v-stepper-content step="2">
                      <v-card flat class="body-2 mt-2 pa-0">
                        <custom-file-upload
                          :refresh="fileUploadRefresh"
                          :multiple="true"
                          @setMedias="updateMedias"
                        />
                      </v-card>
                    </v-stepper-content>
                  </v-stepper>
                  <div class="text-right pa-3">
                    <v-btn text color="info" @click="mainStep=2">
                      <v-icon small style="margin-right: 5px;" >mdi-arrow-left-circle</v-icon>
                        Back
                    </v-btn>
                    <v-btn color="secondary" @click="createCampaignPayout">Submit Payout</v-btn>
                  </div>
                </v-stepper-content>
              </v-stepper-items>
            </v-stepper>
          </div>
        </v-flex>
        <v-dialog
          v-model="loading"
          hide-overlay
          persistent
          width="300"
        >
          <v-card color="primary" dark>
            <v-card-text>
              Please stand by
              <v-progress-linear
                indeterminate
                color="white"
                class="mb-0"
              ></v-progress-linear>
            </v-card-text>
          </v-card>
        </v-dialog>
        <payout-sample-modal
          v-model="payoutSampleDialog"
          :type="sampleType"
        />
      </v-row>
    </v-app>
</template>

<script>
import PostDeliverables from '../../scoped/post/Deliverables';
import CustomFileUpload from '../../scoped/custom/CustomFileUpload';
import userAPIs from '../User/userAPIs'
import postAPIs from '../Post/postApi'
import campaignAPIs from '../Campaign/campaignAPIs'
import paymentAPIs from './paymentAPIs'
import pairingAPIs from '../Pairing/pairingAPIs';
import influencerAPIs from './influencerAPIs'
import campaignConfig from '../Campaign/config'
import utils from '../../../utils';
import Jimp from 'jimp';
import { mapState, mapGetters } from 'vuex'
import PayoutSampleModal from './PayoutSampleModal';
import countries from '../../../../static/sources/countries';
import config from '@/config'

export default {
  name: 'SubmitPayout',
  components: {
    PostDeliverables,
    PayoutSampleModal,
    CustomFileUpload
  },
  data () {
    return {
      user: {},
      loading: false,
      urlIncluded: false,
      mainStep: 1,
      firstActiveStep: 1,
      secondActiveStep: 1,
      thirdActiveStep: 1,
      campaignPayout: {
        campaignName: '',
        campaignID: '',
        postID: '',
        otherSocialMediaPostUrl: '',
        // keep old rating vars to show in previous entries of campaign payout view
        satisfactionLevel: 0,
        kobeSatisfactionLevel: 0,
        advertiserSatisfactionLevel: 0,
        collaboration: '',
        improved: '',
        // new update ratings
        promotingProducts: '',
        audienceEnjoyment: '',
        otherCampaigns: ''
      },
      rules: {
        required: v => !!v || 'This field is required'
      },
      payoutImages: [],
      images: [],
      deliverables: null,
      // customImages: {},
      // customShowImages: {},
      firstSteppers: [],
      campaigns: [],
      allBanks: [],
      bankNames: [],
      editProfile: false,
      editData: {},
      isStoryTell: false,
      payoutSampleDialog: false,
      sampleType: '',
      payoutSampleTimer: null,
      autoShownPayoutSampleSteps: {},
      mediaFiles: [],
      fileUploadRefresh: false
    }
  },
  created() {
    if (this.$route.query.id) {
      this.preLoadData(this.$route.query.id)
    }
    if (this.$route.query.pairingID) {
      this.getPairingDetails(this.$route.query.pairingID)
    }
  },
  computed: {
    ...mapState({
      pairingDetails: state => state.pairing.pairingDetails
    }),
    ...mapGetters('pairing', {
      pairingStatus: 'status'
    }),
    statusACCEPTED() {
      // return campaignConfigs.pairingStatus.ACCEPT;
      return this.pairingStatus.ACCEPTED.value;
    },
    isCampaign() {
      if (this.$route.query.id) {
        return true
      }
      return false
    },
    isPairing() {
      if (this.$route.query.pairingID) {
        return true
      }
      return false
    },
    currentUserID: function () {
      return this.$store.state.user.id
    },
    isCurrentUser: function () {
      return this.$store.state.user
    },
    isNotInfluencer: function () {
      const role = Number(this.$store.state.user.role)
      return role !== config.userRoles.INFLUENCER
    },
    disableStepTwo: function () {
      return !this.campaignPayout.promotingProducts || !this.campaignPayout.improved || !this.campaignPayout.audienceEnjoyment
    },
    numberOfTikTokPost: function() {
      if (this.deliverables) {
        return this.deliverables.no_of_tiktok_posts
      } else return null
    },
    numberOfPost: function() {
      if (this.deliverables) {
        return this.deliverables.no_of_posts
      } else return null
    },
    numberOfCarousels: function() {
      if (this.deliverables) {
        return this.deliverables.no_of_carousels
      } else return null
    },
    numberOfStories: function() {
      if (this.deliverables) {
        return this.deliverables.no_of_stories
      } else return null
    },
    numberOfVideo: function() {
      if (this.deliverables) {
        return this.deliverables.no_of_video
      } else return null
    },
    numberOfIGReels: function() {
      if (this.deliverables) {
        return this.deliverables.no_of_reels
      } else return null
    },
    numberOfFBPosts: function() {
      if (this.deliverables) {
        return this.deliverables.no_of_fb_posts
      } else return null
    },
    numberOfLinkedInPosts: function() {
      if (this.deliverables) {
        return this.deliverables.no_of_li_posts
      } else return null
    },
    numberOfXPosts: function() {
      if (this.deliverables) {
        return this.deliverables.no_of_x_posts
      } else return null
    },
    numberOfXHSPosts: function() {
      if (this.deliverables) {
        return this.deliverables.no_of_xhs_posts
      } else return null
    },
    numberOfYoutubePosts: function() {
      if (this.deliverables) {
        return this.deliverables.youtube
      } else return null
    },
    numberOfCustoms: function() {
      if (this.deliverables) {
        return this.deliverables.custom || []
      } else return []
    }
  },
  watch: {
    firstActiveStep(newStep, previousStep) {
      if (newStep === previousStep || this.mainStep !== 1) return

      const activeStepper = this.firstSteppers[Number(newStep) - 1]
      if (!activeStepper) return

      const activeSampleType = this.getPayoutSampleType(activeStepper)
      if (!this.isSupportedPayoutSampleType(activeSampleType)) return

      const stepKey = this.getPayoutSampleStepKey(newStep, activeStepper)
      if (this.autoShownPayoutSampleSteps[stepKey]) return
      this.$set(this.autoShownPayoutSampleSteps, stepKey, true)

      this.$nextTick(() => {
        this.showPayoutSampleDialog(activeSampleType)
      })
    }
  },
  methods: {
    scrollTopFunction() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    deleteImage(imgIndex) {
      let imgName = this.images[imgIndex].name;
      this.images.splice(imgIndex, 1);
      // remove image from postmedia object
      let index = this.payoutImages.findIndex(item => item.name === imgName);
      if (index !== -1) this.payoutImages.splice(index, 1);
    },
    deleteCustomImage(post, imgIndex) {
      let imgName = post.showImages[imgIndex].name;
      post.showImages.splice(imgIndex, 1);
      // remove image from postmedia object
      let index = post.images.findIndex(item => item.name === imgName);
      if (index !== -1) post.images.splice(index, 1);
    },
    buildFormData() {
      this.cleanPayoutPayload(this.campaignPayout)
      let formData = new FormData();
      let payoutData = Object.assign({}, this.campaignPayout);
      formData.append('influencerID', this.user.influencerId)
      formData.append('campaignPayout', JSON.stringify(payoutData));
      // posts images
      if (this.campaignPayout.posts !== undefined) {
        for (let post of this.campaignPayout.posts) {
          for (let img of post.images) {
            formData.append('images', img.file)
          }
        }
      }
      // stories images
      if (this.campaignPayout.stories !== undefined) {
        for (let story of this.campaignPayout.stories) {
          for (let img of story.images) {
            formData.append('images', img.file)
          }
        }
      }
      // deliverable images
      if (this.campaignPayout.deliverablePosts !== undefined) {
        for (let deliverable of this.campaignPayout.deliverablePosts) {
          for (let post of deliverable.posts) {
            for (let img of post.images) {
              formData.append('deliverableImages', img.file)
            }
          }
        }
      }
      for (let val of this.mediaFiles) {
        formData.append('uploadFile', val);
      }
      return formData;
    },
    cleanPayoutPayload() {
      // posts images
      if (this.campaignPayout.posts !== undefined) {
        for (let post of this.campaignPayout.posts) {
          delete post.showImages
        }
      }
      // stories images
      if (this.campaignPayout.stories !== undefined) {
        for (let story of this.campaignPayout.stories) {
          delete story.showImages
        }
      }
      // deliverable images
      if (this.campaignPayout.deliverablePosts !== undefined) {
        for (let deliverable of this.campaignPayout.deliverablePosts) {
          for (let post of deliverable.posts) {
            delete post.showImages
          }
        }
      }
    },
    prepareUpload(e) {
      const uploadedFiles = Object.keys(e.target.files).map(i => e.target.files[i]);
      uploadedFiles.forEach(element => {
        let type = element.type.split('/')[0];
        if (type !== 'video' && type !== 'image') {
          this.$swal('File Type Not Supported, Please select a video or an image');
        } else {
          // Uploaded file is Image
          const reader = new FileReader();
          reader.readAsDataURL(element);
          reader.onload = e => {
            let buffer = e.target.result;
            Jimp.read(buffer, (err, img) => {
              if (err) console.error(111, err);
              img
                .resize(500, Jimp.AUTO)
                .quality(100)
                .getBase64(Jimp.MIME_PNG, (err, buff) => {
                  if (err) console.error(222, err);
                  let file = utils.func.dataURLtoFile(buff, element.name);
                  this.payoutImages.push(file);
                  this.images.push({
                    thumbnail: buff,
                    src: buff,
                    name: element.name
                  });
                });
            });
          };
          // reset the input
          e.target.value = '';
        }
      });
    },
    prepareCustomUpload(e, post) {
      // this.images = []
      // if (this.customImages[name][index] === undefined) {
      //   this.customImages[name][index] = []
      // }
      const uploadedFiles = Object.keys(e.target.files).map(i => e.target.files[i]);
      uploadedFiles.forEach(element => {
        let type = element.type.split('/')[0];
        if (type !== 'video' && type !== 'image') {
          this.$swal('File Type Not Supported, Please select a video or an image');
        } else {
          // Uploaded file is Image
          const reader = new FileReader();
          reader.readAsDataURL(element);
          reader.onload = e => {
            let buffer = e.target.result;
            let file = utils.func.dataURLtoFile(buffer, element.name);
            post.images.push({name: element.name, file});
            post.showImages.push({
              thumbnail: buffer,
              src: buffer,
              name: element.name
            });
            this.refreshPayoutJSON()
          };
          // reset the input
          e.target.value = '';
        }
      });
    },
    preLoadData(postId) {
      // get the post Data first
      postAPIs
        .getPostById(postId)
        .then(async (response) => {
          if (response.mainPost.campaignID) {
            this.campaignPayout.postID = response._id
            this.campaignPayout.campaignID = response.mainPost.campaignID
            if (response.mainPost.postURL) {
              this.urlIncluded = true
              this.campaignPayout.instagramPostURL = response.mainPost.postURL
            }
            if (response.influencer) {
              // get Campaign Data
              this.getCampaignData(this.campaignPayout.campaignID, response.influencer.username, response.influencer.platform)
            }
          } else {
            this
              .$swal({
                title: 'Post is not ready',
                type: 'error',
                text: `The post isn't associated with any Campaign.`
              })
              .then(() => this.$router.push({path: '/posts/approved'}))
          }
        })
        .catch(err => {
          this.$swal({
            title: `Can't Load the Post`,
            type: 'error',
            text: err
          }).then(() => this.$router.push({path: '/posts/approved'}))
        }
        );
    },
    async changeCampaign() {
      await this.getCampaignData(this.campaignPayout.campaignID, this.user.handle, this.user.platform)
      this.mainStep = 1
    },
    async getCampaignData(campaignID, username, platform) {
      campaignAPIs
      .getCampaignDetailForStats(campaignID)
      .then(async (campaign) => {
        if (!this.isCurrentUser || this.isNotInfluencer) {
          this.campaigns = [
            {
              id: campaignID,
              name: campaign.name
            }
          ]
          this.campaignPayout.campaignID = campaignID
        }
        this.campaignPayout.campaignName = campaign.name
        this.isStoryTell = false
        if (this.isCurrentUser && !this.isNotInfluencer) {
          if (campaign.campaignType !== 'AOK' && campaign.campaignType !== campaignConfig.campaignType.AOK) {
            await this.getPairingData(campaign.id, username, platform)
          }
        } else {
          this.deliverables = this.pairingDetails.deliverables_details
        }
        this.generateStepper(campaign)
      })
      .catch(err => {
        this.$swal({
          title: `Couldn't get Campaign Information`,
          type: 'error',
          text: err
        }).then(() => this.$router.push({path: '/posts/approved'}))
      });
    },
    async getPairingDetails(pairingID) {
      await this.$store.dispatch('pairing/getPairingDetailsForStats', pairingID)
      if (this.pairingDetails) {
        let influencerID = ''
        let username = ''
        let platform = ''
        if (this.pairingDetails.influencer_details) {
          const influencerDetails = this.pairingDetails.influencer_details
          platform = influencerDetails.platform || ''
          username = this.getPairingHandle(influencerDetails, platform)
          influencerID = influencerDetails.influencerID || ''
          this.campaignPayout.pairingID = pairingID
          this.campaignPayout.influencerID = influencerID
          this.campaignPayout.handle = username
          this.campaignPayout.platform = platform || 'instagram'
          this.campaignPayout.fullName = influencerDetails.fullname || influencerDetails.fullName || ''
          this.campaignPayout.xhsID = influencerDetails.xhsID || ''
        }
        if (this.isCurrentUser) {
          if (influencerID !== this.user.influencerId) {
            this.campaignPayout.campaignID = this.pairingDetails.campaignID
            this.getCampaignData(this.pairingDetails.campaignID, username, platform)
          }
        } else {
          this.campaignPayout.campaignID = this.pairingDetails.campaignID
          this.getCampaignData(this.pairingDetails.campaignID, username, platform)
        }
      }
    },
    async getPairingData(campaignID, username, platform) {
      // get pairing data
      if (!username && platform) {
        return
      }
      const pairings = await pairingAPIs.getPairedInfluencersByCampaign(campaignID)
      const matchesPairingHandle = p => {
        if (p.influencer_details) {
          const influencerDetails = p.influencer_details
          const pairingPlatform = influencerDetails.platform || platform || 'instagram'
          const pairingHandle = this.getPairingHandle(influencerDetails, pairingPlatform)
          return this.normalizeHandle(pairingHandle) === this.normalizeHandle(username) &&
            (!platform || pairingPlatform === platform)
        }
        return false
      }
      let pairingOne = pairings.find(matchesPairingHandle)
      if (!pairingOne) {
        pairingOne = pairings.find(p => p.influencer_details &&
          p.influencer_details.influencerID === this.user.influencerId)
      }
      // console.log(influencerID)
      if (pairingOne) {
        this.deliverables = pairingOne.deliverables_details
        const influencerDetails = pairingOne.influencer_details || {}
        const pairingPlatform = influencerDetails.platform || platform || this.user.platform || 'instagram'
        this.campaignPayout.pairingID = pairingOne.id || pairingOne.pairingID || ''
        this.campaignPayout.influencerID = influencerDetails.influencerID || this.user.influencerId
        this.campaignPayout.handle = this.getPairingHandle(influencerDetails, pairingPlatform) || username
        this.campaignPayout.platform = pairingPlatform
        this.campaignPayout.fullName = influencerDetails.fullname || influencerDetails.fullName || this.user.fullName || ''
        this.campaignPayout.xhsID = influencerDetails.xhsID || ''
      }
    },
    proceedStepTwo() {
      let invalidSteps = this.checkDeliverablePosts()
      if (invalidSteps.length) {
        this.firstActiveStep = invalidSteps[0]
        this.scrollTopFunction()
        return;
      }
      if (this.campaignPayout.advertiserSatisfactionLevel === 0 || this.campaignPayout.kobeSatisfactionLevel === 0) {
        // let ratingStartIndex = this.getRatingStartIndex()
        // let errText = 'The ratings '
        let errText = '<div style="text-align:left;">'
        errText += '<h3 style="margin-top:-10px">Please complete the followings:</h3>'
        if (this.campaignPayout.advertiserSatisfactionLevel === 0) {
          errText += `Step ${this.campaignPayout.deliverablePosts.length + 1}: Ratings for overall experience with client<br>`
        }
        if (this.campaignPayout.kobeSatisfactionLevel === 0) {
          errText += `Step ${this.campaignPayout.deliverablePosts.length + 2}: Ratings for overall experience with Kobe`
        }
        errText += '</div>'
        this.$swal({
          html: errText,
          type: 'warning'
        })
      } else this.mainStep = 2
    },
    createCampaignPayout: function () {
      // if (!this.checkProfileData()) {
      //   return false
      // }
      this.loading = true;
      // const { campaignPayout } = this
      let campaignPayout = this.buildFormData()
      // if (this.validURL(this.campaignPayout.instagramPostURL)) {
      this.$swal({
        title: 'Payment Schedule and Terms',
        html: `<div class="text-left subtitle-1">
        <ol>
        <li> <b>Fees</b> - Creator shall be paid in accordance to the amount stated in the Invoice endorsed on the Platform.</li>
        <li> <b>Payments</b> - Kobe shall pay fees by cheque or bank transfer within forty-five (45) days after submission of your live post URL. Creator must provide all applicable personal and bank account information after receiving the live URL link of your posting upon approval by client.</li>
        <li> <b>Penalty fee</b> - It is the responsibility of the Creator to ensure that all personal and bank account information provided are accurate for payment purposes. Otherwise, a deduction of $5 will be made from the amount stated on the endorsed Invoice should there be a request for payment re-issuance due to wrong information provided by the Influencer.</li>
        <li> <b>Forfeiture</b> - Payment will be forfeited should there be any infringement of rules stated in the Campaign Agreement, email correspondences and the Platform.</li>
        </ol>
        </div>`,
        type: 'info',
        confirmButtonText: 'Agree and Continue',
        cancelButtonText: 'Cancel',
        showCancelButton: true,
        showCloseButton: true
      }).then(result => {
        if (result.value) {
          campaignPayout.influencerID = this.user.influencerId
          paymentAPIs.createCampaignPayout(campaignPayout)
            .then(response => {
              if (!this.isCampaign) {
                // for campaign level payout, no posts to publish and return;
                this.showPayoutSuccessMsg()
                return;
              }
              // change post stats to publish
              postAPIs.publishPost(this.campaignPayout.postID, this.campaignPayout.instagramPostURL, true)
                .then(() => {
                  this.showPayoutSuccessMsg(true)
                })
                .catch(() => {
                  this.loading = false;
                  this.$swal({
                    type: 'error',
                    title: 'Error in marking as publish for the post',
                    text: `Don't worry, your payout submission is submitted.`
                  });
                });
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                type: 'error',
                title: 'Error in submitting payout!',
                text: error
              })
            })
        } else {
          this.loading = false;
        }
      });
    },
    generateStepper(campaign) {
      this.firstSteppers = []
      this.firstActiveStep = 1
      this.autoShownPayoutSampleSteps = {}
      if (campaign.campaignType === 'AOK' || campaign.campaignType === campaignConfig.campaignType.AOK) {
        this.generateAOKStepper()
      } else {
        this.isStoryTell = true
        this.generateStoryTellStepper()
      }
      this.firstSteppers.push(
        this.stepperType('advertiserSatisfactionLevel'),
        this.stepperType('kobeSatisfactionLevel')
      )
      this.schedulePayoutSample()
    },
    generateAOKStepper() {
      this.firstSteppers.push(this.stepperType('storyCoverage'))
      this.firstSteppers.push(this.stepperType('postURL'))
      this.campaignPayout.posts = []
      this.campaignPayout.stories = []
      this.addMore('posts')
      this.addMore('stories')
    },
    generateStoryTellStepper() {
      if (!this.deliverables) {
        return;
      }
      let name = ''
      let sample = ''
      let deliverablePosts = []
      if (this.numberOfTikTokPost > 0) {
        name = 'TTP'
        sample = 'tiktok'
        this.firstSteppers.push(this.stepperType('deliverable', {name}))
        deliverablePosts.push(this.getPostArray(this.numberOfTikTokPost, name, sample))
      }
      if (this.numberOfPost > 0) {
        name = 'IGP'
        sample = 'igPost'
        this.firstSteppers.push(this.stepperType('deliverable', {name}))
        deliverablePosts.push(this.getPostArray(this.numberOfPost, name, sample))
      }
      if (this.numberOfCarousels > 0) {
        name = 'IGC'
        sample = 'igPost'
        this.firstSteppers.push(this.stepperType('deliverable', {name}))
        deliverablePosts.push(this.getPostArray(this.numberOfCarousels, name, sample))
      }
      if (this.numberOfStories > 0) {
        name = 'IGS'
        sample = 'igStory'
        this.firstSteppers.push(this.stepperType('deliverable', {name}))
        deliverablePosts.push(this.getPostArray(this.numberOfStories, name, sample))
      }
      if (this.numberOfVideo > 0) {
        name = 'IGV'
        sample = 'igPost'
        this.firstSteppers.push(this.stepperType('deliverable', {name}))
        deliverablePosts.push(this.getPostArray(this.numberOfVideo, name, sample))
      }
      if (this.numberOfIGReels > 0) {
        name = 'IGR'
        sample = 'igReel'
        this.firstSteppers.push(this.stepperType('deliverable', {name}))
        deliverablePosts.push(this.getPostArray(this.numberOfIGReels, name, sample))
      }
      if (this.numberOfXHSPosts > 0) {
        name = 'XHS'
        sample = 'xhs'
        this.firstSteppers.push(this.stepperType('deliverable', {name}))
        deliverablePosts.push(this.getPostArray(this.numberOfXHSPosts, name, sample))
      }
      if (this.numberOfYoutubePosts > 0) {
        name = 'Youtube'
        sample = 'youtube'
        this.firstSteppers.push(this.stepperType('deliverable', {name}))
        deliverablePosts.push(this.getPostArray(this.numberOfYoutubePosts, name, sample))
      }
      if (this.numberOfFBPosts > 0) {
        name = 'FBP'
        sample = 'facebook'
        this.firstSteppers.push(this.stepperType('deliverable', {name}))
        deliverablePosts.push(this.getPostArray(this.numberOfFBPosts, name, sample))
      }
      if (this.numberOfLinkedInPosts > 0) {
        name = 'LIP'
        sample = 'linkedin'
        this.firstSteppers.push(this.stepperType('deliverable', {name}))
        deliverablePosts.push(this.getPostArray(this.numberOfLinkedInPosts, name, sample))
      }
      if (this.numberOfXPosts > 0) {
        name = 'XTP'
        sample = 'twitter'
        this.firstSteppers.push(this.stepperType('deliverable', {name}))
        deliverablePosts.push(this.getPostArray(this.numberOfXPosts, name, sample))
      }
      if (this.numberOfCustoms.length > 0) {
        for (let custom of this.deliverables.custom) {
          let customName = custom.label
          sample = 'custom'
          this.firstSteppers.push(this.stepperType('deliverable', {name: customName}))
          deliverablePosts.push(this.getPostArray(custom.value, customName, sample))
        }
      }
      this.campaignPayout.deliverablePosts = deliverablePosts
      this.refreshPayoutJSON()
    },
    getPostArray(total, type, sampleType) {
      let posts = []
      for (let i = 1; i <= total; i++) {
        posts.push(this.getDeliverableObj(type, i))
      }
      return Object.assign({}, {
        type,
        title: this.getLongTitle(type),
        posts,
        sampleType
      })
    },
    getDeliverablePost(type) {
      if (this.campaignPayout.deliverablePosts) {
        return this.campaignPayout.deliverablePosts.find(post => post.type === type)
      } else return ''
    },
    stepperType(type, fields = {}) {
      return {type, fields}
    },
    clearData: function () {
      this.deliverables = null
      this.firstSteppers = []
      this.autoShownPayoutSampleSteps = {}
      this.campaignPayout = {
        campaignName: '',
        otherSocialMediaPostUrl: '',
        // keep old rating vars to show in previous entries of campaign payout view
        satisfactionLevel: 0,
        kobeSatisfactionLevel: 0,
        advertiserSatisfactionLevel: 0,
        collaboration: '',
        improved: '',
        // new update feedbacks
        promotingProducts: '',
        audienceEnjoyment: '',
        otherCampaigns: ''
      }
    },
    validURL (str) {
      var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
        '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
        '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
        '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
        '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
      return !!pattern.test(str);
    },
    showFileUploader(id) {
      /* eslint-env jquery */
      $('#' + id).click()
    },
    addMore(type, index = null) {
      if (type === 'posts') {
        this.campaignPayout.posts.push({
          instagramPostURL: '',
          images: [],
          showImages: []
        })
      }
      if (type === 'stories') {
        this.campaignPayout.stories.push({
          label: '',
          images: [],
          showImages: []
        })
      }
      if (type === 'deliverables') {
        let postOne = this.campaignPayout.deliverablePosts[index]
        postOne.posts.push(this.getDeliverableObj(postOne.type, postOne.posts.length + 1))
      }
      this.refreshPayoutJSON()
    },
    getDeliverableObj(type, number) {
      return {
        label: '',
        images: [],
        showImages: []
      }
    },
    getLongTitle(title) {
      let titleText = 'Enter the URL, Stats for '
      if (title === 'TTP') {
        return `${titleText} TikTok Post`
      } else if (title === 'IGP') {
        return `${titleText} IG Post`
      } else if (title === 'IGC') {
        return `${titleText} IG Carousel`
      } else if (title === 'IGS') {
        return `Upload your stats for IG Story(ies)`
      } else if (title === 'IGV') {
        return `${titleText} IG VIdeo`
      } else if (title === 'IGR') {
        return `${titleText} IG Reel(s)`
      } else if (title === 'LIP') {
        return `${titleText} LinkedIn Post`
      } else if (title === 'XTP') {
        return `${titleText} X (Twitter) Post`
      } else {
        return `${titleText} ${title}`
      }
    },
    getLabel(type) {
      if (type === 'IGS') {
        return 'label'
      } else return 'Post URL'
    },
    getHint(type) {
      if (type === 'IGS') {
        return 'label IGS 1, IGS 2 etc for multiple stories'
      } else return ''
    },
    getPairingHandle(influencerDetails, platform) {
      if (!influencerDetails) return ''
      if (platform === 'linkedin') {
        return influencerDetails.linkedinHandle || influencerDetails.userHandle || influencerDetails.instagramHandle || ''
      }
      if (platform === 'twitter') {
        return influencerDetails.twitterHandle || influencerDetails.userHandle || influencerDetails.instagramHandle || ''
      }
      return influencerDetails.userHandle || influencerDetails.instagramHandle || ''
    },
    normalizeHandle(handle) {
      return String(handle || '').trim().replace(/^@/, '').toLowerCase()
    },
    refreshPayoutJSON() {
      var tmp = Object.assign({}, this.campaignPayout)
      this.campaignPayout = tmp
    },
    async getInfluencerCampaigns() {
      this.campaigns = await pairingAPIs.getInvitedCampaigns(this.user.influencerId, `${this.statusACCEPTED}`)
    },
    showPayoutSuccessMsg(redirect = false) {
      this.loading = false;
      this.clearData()
      this.$swal({
        title: 'Payout Submitted',
        html: `<div class="text-left subtitle-1">
        <ul>
        <li style='list-style:none'>Your content will remain publicly accessible through your social media account(s) for a minimum of six (6) months, and you do not work with a competitor brand for the next 4 weeks unless otherwise stated.</li>
        </ul>
        </div>`,
        type: 'success'
      }).then(() => {
        if (redirect) {
          this.$router.push({path: '/posts/published'})
        } else {
          this.$router.push({path: '/'})
        }
      });
    },
    async openProfileEdit() {
      this.editData = Object.assign({}, this.user)
      this.editProfile = true
      if (!this.allBanks.length) {
        this.getBankInfo()
      }
    },
    saveProfile() {
      this.$swal({
        title: 'Confirm Update!',
        text: 'Are you sure you want update?',
        confirmButtonText: 'Confirm',
        type: 'info',
        showCancelButton: true,
        showCloseButton: true
      }).then(result => {
        if (result.value) {
          this.loading = true;
          let formData = this.buildProfileFormData()
          // Edit User
          userAPIs
            .editProfile(formData)
            .then(() => {
              // Success Message
              this.loading = false;
              this.$swal({
                title: 'Successfully updated!',
                text: 'Your profile has been updated successfully. Thank you for working with us!',
                type: 'success'
              });
              // update user object
              this.user = Object.assign({}, this.editData)
              this.cancelEdit()
            })
            .catch(error => {
              // Display popup message
              this.loading = false;
              this.$swal({
                title: 'Error!',
                text: 'Please kindly try again or contact us!',
                type: 'error'
              });

              // Request failed.
              console.log('error', error);
            });
        }
      });
    },
    buildProfileFormData() {
      if (typeof this.editData.bankName === 'object') {
        this.editData.swiftCode = this.editData.bankName.swift_code
        this.editData.bankName = this.editData.bankName.bank
      }
      let data = Object.assign({}, {
        id: this.currentUserID,
        fullName: this.editData.fullName,
        bankName: this.editData.bankName,
        swiftCode: this.editData.swiftCode,
        bankAccount: this.editData.bankAccount,
        email: this.editData.email,
        mailingAddress: this.editData.mailingAddress,
        briefUpdate: true
      })
      let formData = new FormData();
      formData.append('editProfile', JSON.stringify(data));
      return formData
    },
    cancelEdit() {
      this.editData = {}
      this.editProfile = false
    },
    async getBankInfo() {
      // Retrieve countries manually
      try {
        this.bankNames = []
        let country = countries.find(c => c.name === this.user.country)
        if (!country) {
          this.bankNames = []
          return;
        }
        await this.getBanks(country.code)
        let matchBank = this.allBanks.find(bank => bank.country_code === country.code)
        if (matchBank && matchBank.list !== undefined) {
          this.bankNames = matchBank.list.filter(bank => bank.branch === null)
        }
      } catch (err) {
        console.log(err)
        this.bankNames = []
      }
    },
    getRatingStartIndex() {
      return this.firstSteppers.findIndex(step => step.type === 'advertiserSatisfactionLevel')
    },
    deletePostGroup(groupArray, index) {
      groupArray.splice(index, 1)
      this.refreshPayoutJSON()
    },
    async getBanks(code) {
      try {
        this.allBanks = await influencerAPIs.getBanks(code)
      } catch (error) {
        console.log('error', error);
      }
    },
    showPayoutSampleDialog(type) {
      if (this.payoutSampleTimer) {
        clearTimeout(this.payoutSampleTimer)
        this.payoutSampleTimer = null
      }
      this.sampleType = type
      this.payoutSampleDialog = true
    },
    getPayoutSampleType(stepper) {
      if (!stepper) return ''
      if (stepper.type === 'storyCoverage') return 'igStory'
      if (stepper.type !== 'deliverable') return ''

      const deliverable = this.getDeliverablePost(stepper.fields.name)
      return deliverable ? deliverable.sampleType : ''
    },
    isSupportedPayoutSampleType(type) {
      return ['igReel', 'igPost', 'igStory', 'tiktok', 'xhs', 'facebook', 'linkedin', 'twitter'].includes(type)
    },
    getPayoutSampleStepKey(stepNumber, stepper) {
      const deliverableName = stepper && stepper.fields ? stepper.fields.name || '' : ''
      return `${stepNumber}:${stepper.type}:${deliverableName}`
    },
    schedulePayoutSample() {
      if (this.payoutSampleTimer) {
        clearTimeout(this.payoutSampleTimer)
      }

      const stepIndex = this.firstSteppers.findIndex(stepper =>
        this.isSupportedPayoutSampleType(this.getPayoutSampleType(stepper))
      )
      if (stepIndex < 0) return

      const stepper = this.firstSteppers[stepIndex]
      const sampleType = this.getPayoutSampleType(stepper)
      const stepKey = this.getPayoutSampleStepKey(stepIndex + 1, stepper)

      this.payoutSampleTimer = setTimeout(() => {
        this.payoutSampleTimer = null
        if (this.autoShownPayoutSampleSteps[stepKey]) return
        this.$set(this.autoShownPayoutSampleSteps, stepKey, true)
        this.showPayoutSampleDialog(sampleType)
      }, 3000)
    },
    checkProfileData() {
      // check profile info in payout submission
      if (!this.user.fullName ||
      !this.user.bankName ||
      !this.user.bankAccount ||
      !this.user.email ||
      !this.user.mailingAddress) {
        this.$swal({
          title: 'Error',
          type: 'error',
          text: `Please update your profile before submission.`
        })
        this.thirdActiveStep = 1
        return false
      }
      return true
    },
    checkDeliverablePosts() {
      let steps = []
      if (this.campaignPayout.deliverablePosts !== undefined) {
        for (const [key, deliverable] of Object.entries(this.campaignPayout.deliverablePosts)) {
          let stepInvalid = false
          for (let post of deliverable.posts) {
            if (!post.label || !post.images.length) {
              stepInvalid = true
            }
          }
          if (stepInvalid) steps.push(parseInt(key) + 1)
        }
      }
      return steps
    },
    updateMedias(medias) {
      this.mediaFiles = Object.assign([], medias)
    },
    isVideo(thumbnail) {
      return thumbnail.includes('video')
    },
    checkOpenBillingDialog(currentInf) {
      if (!currentInf.fullName ||
      !currentInf.country ||
      !currentInf.bankName ||
      !currentInf.bankAccount ||
      !currentInf.billingEmail ||
      !currentInf.mailingAddress
      ) {
        this.$router.push({path: '/profile'})
      }
    }
  },
  mounted() {
    if (!this.isCurrentUser || this.isNotInfluencer) {
      return
    }
    // Retrieve user profile
    userAPIs.getUser(this.currentUserID)
      .then(async (response) => {
        // if no inf platforms
        if (response.influencer) {
          let inf = response.influencer
          if (!inf.instagram && !inf.tiktok && !inf.youtube && !inf.linkedin && !inf.twitter &&
          !inf.reqIgHandle && !inf.reqTikTokHandle && !inf.reqYoutubeHandle) {
            this.$swal({
              text: 'Please Connect Platform',
              type: 'warning',
              allowOutsideClick: false
            }).then(result => {
              if (result.value) {
                // this.$router.push({path: '/profile'})
              }
            })
          }
          if (inf) {
            this.checkOpenBillingDialog(inf)
          }
        }
        // This is for Influencer, we will use the email from Influencer service
        this.user = {
          firstName: response.firstName,
          lastName: response.lastName,
          email: response.influencer.email,
          country: response.influencer.country,
          birthday: response.influencer.birthday,
          gender: response.influencer.gender,
          fullName: response.influencer.fullName,
          bankName: response.influencer.bankName,
          bankAccount: response.influencer.bankAccount,
          swiftCode: response.influencer.swiftCode,
          mailingAddress: response.influencer.mailingAddress,
          influencerId: response.influencer.id
        }
        const activePlatform = response.influencer.activePlatform
        if (activePlatform === 'linkedin' && response.influencer.linkedin) {
          this.user.handle = response.influencer.linkedin.linkedinHandle
          this.user.platform = 'linkedin'
        } else if (activePlatform === 'twitter' && response.influencer.twitter) {
          this.user.handle = response.influencer.twitter.twitterHandle
          this.user.platform = 'twitter'
        } else if (activePlatform === 'tiktok' && response.influencer.tiktok) {
          this.user.handle = response.influencer.tiktok.tiktokHandle
          this.user.platform = 'tiktok'
        } else if (activePlatform === 'instagram' && response.influencer.instagram) {
          this.user.handle = response.influencer.instagram.instagramHandle
          this.user.platform = 'instagram'
        } else if (response.influencer.tiktok) {
          this.user.handle = response.influencer.tiktok.tiktokHandle
          this.user.platform = 'tiktok'
        } else if (response.influencer.instagram) {
          this.user.handle = response.influencer.instagram.instagramHandle
          this.user.platform = 'instagram'
        } else if (response.influencer.linkedin) {
          this.user.handle = response.influencer.linkedin.linkedinHandle
          this.user.platform = 'linkedin'
        } else if (response.influencer.twitter) {
          this.user.handle = response.influencer.twitter.twitterHandle
          this.user.platform = 'twitter'
        }
        if (!this.isCampaign) {
          await this.getInfluencerCampaigns()
        }
        if (this.isPairing) {
          await this.getPairingDetails(this.$route.query.pairingID)
        }
      })
      .catch(error => {
        // Request failed.
        console.log('error', error)
      })
  },
  beforeDestroy() {
    if (this.payoutSampleTimer) {
      clearTimeout(this.payoutSampleTimer)
    }
  }
}
</script>
<style>
  .submit-post-payout .stepper-items .v-stepper__label {
    display: block!important;
    padding-left: 10px;
  }
</style>
<style scoped>
  .card-box {
    margin: 10px;
  }
  .img-box {
    z-index: 1;
    max-height: 200px;
    max-width: 200px;
  }
  table {
  border-collapse: collapse;
  width: 100%;
  }
  table td .edit-field {
    font-size:13px;
  }
  th, td {
    padding: 8px;
    text-align: left;
    border-bottom: 1px solid #ddd;
    border-left: 1px solid #ddd;
  }
  tr:hover {background-color:#f5f5f5;}
  .caption {
    padding: 8px;
    font-style: italic;
  }
  .deliverables {
    font-size: 15px;
    font-weight: 400;
  }
  .deliverables ul{
    font-weight: 600;
    line-height: 1.5rem;
  }
</style>



// WEBPACK FOOTER //
// SubmitPostPayout.vue?699a58fa